import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  schema, // Can be a single object or array of objects
  faqs,   // Optional: array of {q, a} for FAQPage schema
  steps,  // Optional: array of {name, text} for HowTo schema
  image = '/og-image.png', 
  article = false 
}) => {
  const { pathname } = useLocation();
  const siteUrl = 'https://joyfileconvert.com';
  const fullUrl = `${siteUrl}${pathname}`;
  const defaultTitle = 'Joy File Convert - Free Local File Converter';
  const seoTitle = title ? (title.includes('Joy File Convert') ? title : `${title} | Joy File Convert`) : defaultTitle;

  // Generate FAQ Schema
  const faqSchema = faqs ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": f.a
      }
    }))
  } : null;

  // Generate HowTo Schema
  const howToSchema = steps ? {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": `How to ${title.toLowerCase()}`,
    "description": description,
    "step": steps.map((s, i) => ({
      "@type": "HowToStep",
      "position": i + 1,
      "name": s.name,
      "itemListElement": [{
        "@type": "HowToDirection",
        "text": s.text
      }]
    }))
  } : null;

  const allSchemas = [
    ...(Array.isArray(schema) ? schema : schema ? [schema] : []),
    ...(faqSchema ? [faqSchema] : []),
    ...(howToSchema ? [howToSchema] : [])
  ];

  return (
    <Helmet>
      {/* General Meta */}
      <title>{seoTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data */}
      {allSchemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}

      {/* OpenGraph */}
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${image}`} />
      <meta property="og:site_name" content="Joy File Convert" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${image}`} />
    </Helmet>
  );
};

export default SEO;
